import { useIntl } from 'react-intl';

export const useTranslations = () => {
  const translations = useIntl();
  const translate = (key: string, defaultMessage?: string) => translations.formatMessage({ id: key, defaultMessage }) || key;
  return translate;
};
